import { Button, PhoneInput, Title } from '@qonsoll/react-design'
import { Form, Input, InputNumber } from 'antd'
import { KEYS, MAX_LENGTH_FIELD } from '__constants__'

import { ImageUploader } from 'components'
import PropTypes from 'prop-types'
import { useTranslations } from 'contexts/Translation'

const EditorSimpleForm = (props) => {
  const { initialValues, onSubmit, onCancel, showTitle, form, group, isEdit } =
    props

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting new form instance from Form.useForm hook */
  const [baseForm] = Form.useForm()

  /* Getting used form from props or using base form */
  const usedForm = form || baseForm

  /* Resetting form on cancel */
  const handleCancel = () => {
    usedForm.resetFields()
    onCancel?.()
  }
  /* Submitting form on enter key press */
  const handleKeyPress = (e) => {
    if (e.key === KEYS.ENTER) {
      e.preventDefault()
      e.stopPropagation()
      usedForm?.submit()
    }
  }
  const requiredRule = (errorMsg) => ({
    required: true,
    message: t(errorMsg)
  })
  const maxLengthRule = (errorMsg) => ({
    max: MAX_LENGTH_FIELD,
    message: t(errorMsg)
  })
  const isEmailValid = (errorMsg) => ({
    type: 'email',
    message: t(errorMsg)
  })

  return group ? (
    <>
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Editor')}
        </Title>
      )}
      <Form.Item label={t('Avatar')} name={[...group, 'avatarUrl']}>
        <ImageUploader />
      </Form.Item>
      <Form.Item
        label={t('First name')}
        name={[...group, 'firstName']}
        rules={[
          requiredRule('Please enter your editor first name!'),
          maxLengthRule('Editor first name is too long!')
        ]}>
        <Input
          type="email"
          placeholder={t('Please enter your editor first name')}
        />
      </Form.Item>
      <Form.Item
        label={t('Last name')}
        name={[...group, 'lastName']}
        rules={[
          requiredRule('Please enter your editor last name!'),
          maxLengthRule('Editor last name is too long!')
        ]}>
        <Input placeholder={t('Please enter your editor  last name')} />
      </Form.Item>
      <Form.Item
        label={t('Email')}
        name={[...group, 'email']}
        rules={[
          requiredRule('Please enter your editor email!'),
          isEmailValid('Email is not valid'),
          maxLengthRule('Editor email is too long!')
        ]}>
        <Input
          placeholder={t('Please enter your editor email')}
          disabled={isEdit}
        />
      </Form.Item>
      <Form.Item
        label={t('Mobile number')}
        name={[...group, 'phoneNumber']}
        rules={[requiredRule('Please enter phone number!')]}>
        <PhoneInput
          country="no"
          preferredCountries={['no']}
          specialLabel=""
          placeholder={t('Please enter phone number')}
        />
      </Form.Item>
    </>
  ) : (
    <Form
      form={usedForm}
      initialValues={initialValues}
      onFinish={onSubmit}
      layout="vertical"
      onKeyPress={handleKeyPress}
      autoComplete="off">
      {showTitle && (
        <Title level={4} mb={2}>
          {t('Editor')}
        </Title>
      )}
      <Form.Item label={t('Avatar')} name={[...group, 'avatarUrl']}>
        <ImageUploader />
      </Form.Item>
      <Form.Item
        label={t('Name')}
        name="name"
        rules={[
          requiredRule('Please enter your editor first name!'),
          maxLengthRule('Editor name is too long!')
        ]}>
        <Input placeholder={t('Please enter your editor name')} />
      </Form.Item>
      <Form.Item
        label={t('Sno')}
        name="sno"
        rules={[requiredRule('Please enter your editor sno!')]}>
        <InputNumber placeholder={t('Please enter your editor sno')} />
      </Form.Item>
      <Form.Item
        label={t('Email')}
        name="email"
        rules={[
          requiredRule('Please enter your editor email!'),
          isEmailValid('Email is not valid'),
          maxLengthRule('Editor email is too long!')
        ]}>
        <Input placeholder={t('Please enter your editor email')} />
      </Form.Item>
      <Form.Item
        label={t('Mobile number')}
        name="phoneNumber"
        rules={[requiredRule('Please enter phone number!')]}>
        <PhoneInput
          country="no"
          preferredCountries={['no']}
          specialLabel=""
          placeholder={t('Please enter phone number')}
        />
      </Form.Item>
      <Form.Item
        label={t('Total tips')}
        name="totalTips"
        rules={[requiredRule('Please enter your editor total tips!')]}>
        <InputNumber placeholder={t('Please enter your editor total tips')} />
      </Form.Item>
      {!form && (
        <>
          <Button mr={2} htmlType="button" onClick={handleCancel}>
            {t('Cancel')}
          </Button>
          <Button type="primary" onClick={() => usedForm.submit()}>
            {t('Save')}
          </Button>
        </>
      )}
    </Form>
  )
}

EditorSimpleForm.propTypes = {
  initialValues: PropTypes.object,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  showTitle: PropTypes.bool,
  form: PropTypes.any,
  group: PropTypes.array,
  isEdit: PropTypes.bool
}

export default EditorSimpleForm
